module.exports = __webpack_public_path__ + "static/media/reward_wallet_modal_asset_02.0c6f3251.svg";